import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import type { ProductModificationPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';
import * as actionTypes from 'state/productModificationForm/productModificationForm.actionTypes';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceTabCreated } from 'state/workspaces/workspace.actions';
import { throwOnTimeout } from 'utils/rxjs';

export function createProductModificationTabEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, _state$, { navigateTo, httpClient }) => {
    return action$.pipe(
      ofType(actionTypes.PRODUCT_MODIFICATION_TAB_CREATED),
      mergeMap(({ tabId, productId, tabName }) => {
        const content: ProductModificationPersistedTabContent = {
          workspace: 'postTrade',
          tabType: 'productModification',
          productId,
        };

        return tabsApiConnector(httpClient, 'postTrade')
          .updateTabContent(tabId, content)
          .pipe(
            throwOnTimeout(timeoutInMillis, `Timeout after ${timeoutInMillis}ms.`, appScheduler),
            mergeMap(() => of(workspaceTabCreated(tabId, content.workspace, content.tabType, tabName))),
            tap(() => navigateTo('/post-trade')),
            catchError(() => EMPTY),
          );
      }),
    );
  };
}
